import { render, staticRenderFns } from "./LEDCanvas.vue?vue&type=template&id=69a5e50e&scoped=true&"
import script from "./LEDCanvas.vue?vue&type=script&lang=js&"
export * from "./LEDCanvas.vue?vue&type=script&lang=js&"
import style0 from "./LEDCanvas.vue?vue&type=style&index=0&id=69a5e50e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a5e50e",
  null
  
)

export default component.exports